var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-6 mx-auto" },
      [
        _c("bootstrap-box", {
          staticClass: "newsroom-item",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c("h3", { staticClass: "title news-item-title" }, [
                    _vm._v(_vm._s(_vm.title))
                  ]),
                  _vm._v(" "),
                  _vm.canWrite
                    ? [
                        _c(
                          "router-link",
                          {
                            staticClass: "mdb-icon-btn edit pull-right mt-1",
                            attrs: {
                              to: {
                                name: "newsroom-edit",
                                params: { id: _vm.id }
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-pencil" })]
                        )
                      ]
                    : _vm._e()
                ]
              },
              proxy: true
            },
            {
              key: "body",
              fn: function() {
                return [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("p", { staticClass: "newsroom-item-content" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.content) +
                            "\n                        "
                        )
                      ])
                    ])
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "footer",
              fn: function() {
                return [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("h5", { staticClass: "pull-right mt-2" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm._f("formatDate")(_vm.date)) +
                            "\n                        "
                        )
                      ])
                    ])
                  ])
                ]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }